/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import React, { useCallback } from 'react';
import { format } from 'date-fns';
import { useLocation, useParams } from 'react-router-dom-v5-compat';
import { Card, Button, Input, Dropdown, Label, Dimmer, Placeholder, Segment, Form, Header, Icon, Item } from 'semantic-ui-react';
import { Link  } from 'react-router-dom-v5-compat'
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { exportCampaignSales } from '../../../services/PromotionCampaign/PromotionCampaign.service';
import { notify } from 'react-notify-toast';
import { downloadRemoteFile } from '../../../services/File/File.service';
import { UltyDropdown } from '@ulty/ulty-ui';
import { CampaignStatus } from './CampaignStatus/CampaignStatus';
import { PromotionCampaignCard, PromotionCampaignCardPlaceholder } from './PromotionCampaignCard/PromotionCampaignCard';
import { PromotionCampaignFilters } from './Filters/PromotionCampaignFilters';

const STATUS_DISPLAY_MAP = {
    DRAFT: { color: 'grey'  },
    ENABLED: { color: 'blue' },
    DISABLED: { color: 'grey', basic: true},
    COMPLETED: { color: 'green' },

}


const STATUS_OPTIONS = [
  { key: 'DRAFT', value: 'DRAFT', text: 'Brouillon',label:{color:'grey', empty:true, circular:true} },
  { key: 'ENABLED', value: 'ENABLED', text: 'Activée' ,label:{color:'blue', empty:true, circular:true} },
  { key: 'DISABLED', value: 'DISABLED', text: 'Désactivé' ,label:{color:'grey', basic:true, empty:true, circular:true} },
  { key: 'COMPLETED', value: 'COMPLETED', text: 'Terminé' ,label:{color:'green', empty:true, circular:true} },
];



const PromotionCampaignList = ({ campaigns, currentFilters,isLoading, compact=false }) => {
  const { campaignId } = useParams();

  const {t} = useTranslation();

  // Move current campaign to top
  const filteredCampaigns = React.useMemo(() => {
    if (!campaigns) return [];
    let arr = [...campaigns];
    // Filter by status (multi-select)
    if (currentFilters.status && currentFilters.status.length > 0) {
      arr = arr.filter(c => currentFilters.status.includes(c.status));
    }
    if (campaignId) {
      const idx = arr.findIndex(c => String(c.id) === String(campaignId));
      if (idx > 0) {
        const [current] = arr.splice(idx, 1);
        arr.unshift(current);
      }
    }
    // When compact, only show first 5
    if(compact){
      return arr.slice(0,5);
    }
    return arr;
  }, [campaigns, campaignId, currentFilters,compact]);


  return (
    <div css={css`
        width: 100%;
    `}>
      {isLoading && (
            <Card.Group centered stackable itemsPerRow={compact ? undefined : 1}>
              {Array.from({ length: compact ? 3 : 1 }).map((_, i) => (<PromotionCampaignCardPlaceholder/>))}
            </Card.Group>
          )}
      {campaigns && (
        <Item.Group divided relaxed>
          {filteredCampaigns.map(c => {
            const isActive = campaignId && String(c.id) === String(campaignId);
            return (
              <PromotionCampaignCard key={c.id} campaign={c} isActive={isActive} compact={compact} />
            );
          })}
        </Item.Group>
      )}
      {campaigns && campaigns.length === 0 && !isLoading && (
        <Segment placeholder>
                <Header icon>
                    <Icon name="sticky note outline"/>
                    {t('promotion_campaign.no_campaigns_yet', 'Aucune campagne pour le moment')}
                </Header>
            </Segment>
      )}
    </div>
  );
};

export default PromotionCampaignList;
